import React from 'react';
import styled from 'styled-components';
import { InfoCircleIcon } from 'tdesign-icons-react';
import { Space, Tag } from 'tdesign-react';

export default function ConfirmBind({ primaryClusterName, recoveryClusterName }) {
  return (
    <Root>
      <InfoCircleIcon color='var(--td-brand-color-7)' size={38} />

      <Title>
        <Space size={4} align='center'>
          确定将主集群<Tag>{primaryClusterName}</Tag> 和备集群<Tag>{recoveryClusterName}</Tag>
          完成绑定?
        </Space>
      </Title>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 80px 0 40px;
`;

const Title = styled.div`
  color: var(--td-font-gray-1);
  font-size: 16px;
  margin-top: 20px;
  text-align: center;
`;
